import { useState, useEffect, useContext } from "react";
import {
  CircularProgress,
  Divider,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import requestAdapter from "../../api/request";

import SnackbarContext from "../../contexts/Snackbar";
import { Alert } from "@material-ui/lab";
import ButtonRounded from "../../components/ButtonRounded";
import { TableWithdrawal } from "../../components/TableWithdrawal";

function WithdrawalSettings() {
  const { setSnack } = useContext(SnackbarContext);

  const [loading] = useState(false);
  const [error] = useState({ hasError: false, errorMessage: "" });
  const [initalDate, setInitialDate] = useState();
  const [finalDate, setFinalDate] = useState();
  const [client, setClient] = useState(-1);
  const [users, setUsers] = useState([]);

  const [transactionsInfo, setTransactionsInfo] = useState([]);

  function twoPlaces(number) {
    number = Number(number);
    if (number < 10) return "0" + number;
    return number;
  }

  useEffect(() => {
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 1);
    const final = `${endDate.getFullYear()}-${twoPlaces(
      endDate.getMonth() + 1
    )}-${twoPlaces(endDate.getDate())}`;

    setFinalDate(final);

    endDate.setDate(endDate.getDate() - 30);

    const initial = `${endDate.getFullYear()}-${twoPlaces(
      endDate.getMonth() + 1
    )}-${twoPlaces(endDate.getDate())}`;

    setInitialDate(initial);
    getClients();
    search(initial, final);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getClients() {
    try {
      const res = await requestAdapter.get(`/admin/clients`);
      const ans = [];
      for (const user of res.data.users) {
        ans.push({ value: user.id, name: user.name + " (" + user.taxId + ")" });
      }
      setUsers(ans);
    } catch (ex) {
      setSnack({
        message: "Ocorreu um erro, tente novamente",
        open: true,
        severity: "error",
      });
    }
  }

  function convertDate(date) {
    return (
      date.split("-")[2] + "/" + date.split("-")[1] + "/" + date.split("-")[0]
    );
  }

  async function search(a = null, b = null) {
    try {
      let params =
        "initialDate=" +
        convertDate(a ? a : initalDate) +
        "&&finalDate=" +
        convertDate(b ? b : finalDate);
      if (client && client !== -1) {
        params += "&client=" + client;
      }

      const res = await requestAdapter.get(`/withdrawal/?${params}`);
      const transactions = res.data.withdrawal;
      setTransactionsInfo(transactions);
    } catch (ex) {
      console.log(ex);
      setSnack({
        message: "Ocorreu um erro, tente novamente",
        open: true,
        severity: "error",
      });
    }
  }

  return (
    <div>
      <Grid
        container
        spacing={2}
        alignItems="center"
        style={{
          marginTop: "25px",
          textAlign: "center",
          alignContent: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{ borderRadius: "25px", borderWidth: 1, borderColor: "black" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">Histórico de saques</Typography>
              <Divider
                spacing={4}
                style={{
                  background: "var(--color-orange-mid)",
                  width: "20%",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
            </Grid>
            <Divider
              spacing={4}
              style={{
                background: "var(--color-orange-mid)",
                width: "50%",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: 10,
                marginBottom: 20,
              }}
            />
            <Grid
              justify="center"
              container
              spacing={1}
              style={{ marginBottom: 10, alignItems: "center" }}
            >
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="initialDate"
                  value={initalDate}
                  onChange={(ev) => {
                    setInitialDate(ev.target.value);
                  }}
                  label="Data inicial"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  value={finalDate}
                  size="small"
                  variant="outlined"
                  id="finalDate"
                  onChange={(ev) => {
                    setFinalDate(ev.target.value);
                  }}
                  label="Data final"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} alignItems="center" justify="center">
              <Grid item xs={6}>
                <Select
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={client}
                  label="Cliente"
                  onChange={(ev) => setClient(ev.target.value)}
                >
                  <MenuItem value={-1}>
                    <em>Todos os clientes</em>
                  </MenuItem>
                  {users.map((user) => {
                    return (
                      <MenuItem value={user.value} key={user.value}>
                        {user.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Grid>
              <Grid item style={{ justifyContent: "flex-end" }}>
                <ButtonRounded
                  onClick={() => search()}
                  text={"Buscar"}
                ></ButtonRounded>
              </Grid>
            </Grid>
            <Divider
              spacing={4}
              style={{
                background: "var(--color-orange-mid)",
                width: "50%",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: 10,
              }}
            />
          </Grid>
        </div>
        {error.hasError && (
          <Grid container justify="center">
            <Grid item xs={12} sm={4}>
              <Alert severity="warning" style={{ marginTop: "20px" }}>
                {error.errorMessage}
              </Alert>
            </Grid>
          </Grid>
        )}
      </Grid>

      <div style={{ marginTop: "40px" }}>
        <TableWithdrawal filteredRows={transactionsInfo} />
      </div>

      <Grid
        container
        spacing={0}
        justify="center"
        style={{ marginTop: "10px" }}
      >
        {loading && (
          <Grid item xs={3}>
            <CircularProgress></CircularProgress>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default WithdrawalSettings;
